import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'

// Oeffentliche Demo-Landing-Page (Case-Rahmen): erklaert den Prototypen-
// Charakter und fuehrt zur Selbstregistrierung. Ziel des huebner.io-Kachel-Links.
export function DemoPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-[560px]">
        <div className="mb-8 text-center">
          <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground">Demo · Working Prototype</p>
          <h1 className="mt-2 text-[26px] font-[650] leading-tight tracking-tight text-foreground">MindKeep ausprobieren</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Eine private KI-Wissensbasis, gebaut von Hartmut Hübner — als funktionierender Case, nicht als Folie.
          </p>
        </div>

        <Card>
          <CardContent className="space-y-5 pt-6">
            <ul className="space-y-3 text-sm text-foreground">
              <li className="flex gap-3">
                <span aria-hidden="true" className="mt-0.5 inline-block h-2 w-2 shrink-0 rounded-full bg-primary" />
                <span><strong>Mit Beispiel-Inhalten starten:</strong> Auf Wunsch füllt MindKeep deinen Workspace mit echten Beispiel-Dokumenten (CEO-Guide, Protokolle, Canvas-Vorlagen) — du kannst sofort fragen, zitieren und Outputs erzeugen.</span>
              </li>
              <li className="flex gap-3">
                <span aria-hidden="true" className="mt-0.5 inline-block h-2 w-2 shrink-0 rounded-full bg-primary" />
                <span><strong>EU-only by default:</strong> Verarbeitung mit Mistral-Modellen in Europa, sichtbare Quellen, menschliche Freigabe bei Outputs.</span>
              </li>
              <li className="flex gap-3">
                <span aria-hidden="true" className="mt-0.5 inline-block h-2 w-2 shrink-0 rounded-full bg-primary" />
                <span><strong>Prototyp:</strong> MindKeep ist ein Working Prototype im Rahmen eines Cases — bitte keine vertraulichen Produktivdaten hochladen. Konto und Daten kannst du jederzeit selbst löschen.</span>
              </li>
            </ul>

            <div className="flex flex-col gap-3 pt-1 sm:flex-row">
              <Link
                data-testid="demo-cta-signup"
                to="/auth/signup"
                className="inline-flex min-h-11 min-[761px]:min-h-9 flex-1 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                Kostenlos registrieren
              </Link>
              <Link
                data-testid="demo-cta-login"
                to="/login"
                className="inline-flex min-h-11 min-[761px]:min-h-9 flex-1 items-center justify-center rounded-md border border-input bg-background px-4 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                Anmelden
              </Link>
            </div>

            <p className="text-xs text-muted-foreground">
              Kostenlos im Prototype-Betrieb. Details zu Daten und Verarbeitung stehen in der{' '}
              <Link className="underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm" to="/legal/privacy">Datenschutzerklärung</Link>.
            </p>
          </CardContent>
        </Card>

        <p className="mt-4 text-center text-xs text-muted-foreground">
          <Link className="underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm" to="/legal/privacy">Datenschutzerklärung</Link>
          {' · '}
          <Link className="underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm" to="/legal/terms">Nutzungsbedingungen</Link>
          {' · '}
          <Link className="underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm" to="/legal/impressum">Impressum</Link>
          {' · '}
          <a className="underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm" href="https://huebner.io" target="_blank" rel="noreferrer">huebner.io</a>
        </p>
      </div>
    </div>
  )
}
